import {fetchUserSelfUpdate, UserUpdateDto} from '@blesk-frontend/api';
import {useBleskAuth} from '@blesk-frontend/auth';
import {Button, FieldGroup, Input, Page, PageTitle} from '@blesk-frontend/ui';
import {useEffect} from 'react';
import {useForm} from 'react-hook-form';
import {toast} from 'sonner';
import {GuideListTopbar} from '@/features/guides';
import {TeamsTable} from '@/features/settings';
import {Route} from '@/routes/_app/settings';

export const SettingsPage = () => {
  const title = Route.useRouteContext().getTitle();
  const {
    query: {data: user, refetch},
    updateToken,
  } = useBleskAuth();

  const {
    setValue,
    formState: {isSubmitting, isValid},
    register,
    handleSubmit,
  } = useForm<UserUpdateDto>();

  const onSubmit = handleSubmit(async ({fullName}) => {
    return toast.promise(
      async () => {
        const {accessToken} = await fetchUserSelfUpdate({fullName});
        updateToken(accessToken);
        await refetch();
      },
      {
        loading: 'Сохранение...',
        error: 'При сохранении произошла ошибка',
        success: () => {
          refetch();
          return 'Настройки успешно сохранены';
        },
      },
    );
  });

  useEffect(() => {
    if (user) {
      setValue('fullName', user.fullName);
      setValue('email', user.email);
    }
  }, [user, setValue]);

  return (
    <Page className="flex h-full flex-col">
      <GuideListTopbar />

      <div className="container mx-auto flex h-full max-w-7xl flex-col gap-8">
        <PageTitle>
          <div className="flex h-10 items-center justify-center">
            <span>{title}</span>
          </div>
        </PageTitle>

        <form className="flex max-w-96 flex-col gap-6" onSubmit={onSubmit}>
          <FieldGroup label="Имя" labelFor="fullName">
            <Input
              {...register('fullName', {required: true, minLength: 3})}
              id="fullName"
              type="text"
            />
          </FieldGroup>

          <FieldGroup label="Email" labelFor="email">
            <Input
              {...register('email')}
              id="email"
              type="email"
              placeholder="Введите полное имя"
              disabled={true}
            />
          </FieldGroup>

          <Button className="w-min px-6" type="submit" loading={isSubmitting} disabled={!isValid}>
            <span>Сохранить</span>
          </Button>
        </form>

        <TeamsTable />
      </div>
    </Page>
  );
};
